import axios from 'axios';
import { notifyInvalidTokenFromApi } from '../utils/invalidSession';

const ADMIN_API = 'https://backend.event.quytech.net/v1';

/**
 * Join REACT_APP_API + path without broken slashes.
 * If REACT_APP_API is https://host/v1/vendor, paths must be like /product/... (not /vendor/product/...).
 */
function resolveVendorApiUrl(path) {
	if (!path) return path;
	if (/^https?:\/\//i.test(String(path))) return path;
	let base = String(process.env.REACT_APP_API || '').trim().replace(/\/+$/, '');
	let rel = path.startsWith('/') ? path : `/${path}`;
	// Public user-auth endpoints live under /v1/user while the configured
	// application base normally ends in /v1/vendor.
	if (/\/vendor$/i.test(base) && /^\/user(\/|$)/.test(rel)) {
		base = base.replace(/\/vendor$/i, '');
	}
	// Prevent .../vendor/vendor/... when base already ends with /vendor
	if (/\/vendor$/i.test(base) && /^\/vendor(\/|$)/.test(rel)) {
		rel = rel.replace(/^\/vendor/, '') || '/';
	}
	if (!base) {
		console.warn(
			'[API] REACT_APP_API is not set. Add it to .env (e.g. https://backend.event.quytech.net/v1/vendor)'
		);
		return rel;
	}
	return `${base}${rel}`;
}

export const handleApiCall = async (method = '', url = '', data = {}) => {
	console.log(localStorage?.getItem('sessionToken'), "sessionToken");
	let axiosConfig = {
		method,
		url: resolveVendorApiUrl(url),
		headers: {
			Authorization: `Bearer ${localStorage?.getItem('sessionToken')}`
		}
	};
	const isFormData =
		data && typeof FormData !== 'undefined' && data instanceof FormData;
	if (method === 'get' && data?.params && typeof data.params === 'object') {
		axiosConfig.params = data.params;
	} else if (method !== 'get') {
		axiosConfig.data = data;
		if (!isFormData) {
			axiosConfig.headers['Content-Type'] = 'application/json';
		}
	}
	try {
		let response = await axios(axiosConfig);
		notifyInvalidTokenFromApi(response);
		return response;
	} catch (error) {
		notifyInvalidTokenFromApi(error);
		return error;
	}
};
export const handleAdminApiCall = async (method = '', url = '', data = {}, isAdmin = false) => {

	let axiosConfig = {
		method,
		url: `${ADMIN_API}${url}`,
		headers: {
			Authorization: `Bearer ${localStorage?.getItem('sessionToken')}`
		}
	};
	if (method !== 'get') axiosConfig['data'] = data;
	try {
		let response = await axios(axiosConfig);
		notifyInvalidTokenFromApi(response);
		return response;
	} catch (error) {
		notifyInvalidTokenFromApi(error);
		return error;
	}
};
